import moment from "moment";
import { useState, useCallback } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate, useLocation } from "react-router";
import { Button, Skeleton } from "@mui/material";
import NoDataCard from "../../../components/no-data-card";
import { dateFormater } from "../../utils/common/utils";
import ResetLSMApheresis from "./taskModel";
import { findSlugString, getLastIdFromUrl} from '../../../../src/utils/utils'
import BsModal from "../../components/common/BaseModal"
import AddUpdatePayment from "./AddUpatePayment";


const TaskNotificationTile = ({
  task = [],
  isClosed,
  loadMoreData,
  maxPages,
  page,
  loading,
  hasMoreData = true,
  hideActions = false,
  showBoxShadow = false
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  // const [hasTriedLoadMore, setHasTriedLoadMore] = useState(false);
  const [openModel, setModel] = useState(false);
  const [openModelTask, setOpenModelTask] = useState({});
  const [paymentStatusModal, setPaymentStatusModal] = useState(false);


   const handleCloseModal =() =>{
    navigate(openModelTask?.redirect_uri);
   }
  const handleTaskView = async (taskDetails) => {
   const batchNo =  taskDetails?.finalBatchNo ? '?batch='+taskDetails?.finalBatchNo :'';
    if(findSlugString(taskDetails?.slug) == "payment-status" && taskDetails?.status === 0){
      setPaymentStatusModal(true)
      setOpenModelTask(taskDetails)
    }else if (findSlugString(taskDetails?.slug) == "lsm-rejection" && taskDetails.status == 0) {
      setModel(true)
      setOpenModelTask(taskDetails)
    } else {
      if (taskDetails?.redirect_uri) {
        const url = batchNo ? taskDetails.redirect_uri+batchNo : taskDetails.redirect_uri
        navigate(url);
      } else {
        const prodDetailsId = taskDetails?.subject?.phase?.product_details?.id;
        const phaseId = taskDetails?.subject?.id;
        const isBMRSection = location.pathname.includes("/bmr/");

        if (isBMRSection) {
          navigate(
            `/bmr/products/product-details/${prodDetailsId}/patient-details/${phaseId}${batchNo}`
          );
        } else {
          navigate(
            `/products/product-details/${prodDetailsId}/patient-details/${phaseId}${batchNo}`
          );
        }
      }
    }
  };

  const getTaskColorAndDate = (createdAt, isClosed) => {
    const today = moment().startOf("day");
    const createdDate = moment(createdAt).startOf("day");
    const diffInDays = today.diff(createdDate, "days");

    if (isClosed) {
      return {
        taskColor: "#00B278",
        dateText:
          diffInDays === 0
            ? "Today"
            : `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`,
      };
    }

    if (diffInDays === 0) {
      return {
        taskColor: "#3b82f6",
        dateText: "Today",
      };
    } else if (diffInDays <= 3) {
      return {
        taskColor: "#f97316",
        dateText: `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`,
      };
    }

    return {
      taskColor: "#ef4444",
      dateText: `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`,
    };
  };

  const hasMore = useCallback(() => {
    if (loading || isLoadingMore) {
      return false;
    }

    // Use explicit hasMoreData prop if available
    if (hasMoreData !== undefined) {
      return hasMoreData;
    }

    // Fallback to page-based logic
    if (typeof page === "number" && typeof maxPages === "number") {
      return page < maxPages;
    }

    return false;
  }, [loading, isLoadingMore, hasMoreData, page, maxPages]);

  // FIXED: Improved load more handler
  const handleLoadMore = useCallback(() => {
    if (isLoadingMore || !hasMore()) {
      return;
    }

    setIsLoadingMore(true);

    // Add a small delay to prevent rapid consecutive calls
    setTimeout(() => {
      loadMoreData();
      setIsLoadingMore(false);
    }, 100);
  }, [isLoadingMore, hasMore, loadMoreData]);

  // Loading state for initial load
  if (loading && task.length === 0) {
    return (
      <div className="space-y-4">
        {[...Array(3)].map((_, index) => (
          <Skeleton key={index} height={"150px"} />
        ))}
      </div>
    );
  }

  // Empty state
  if (!loading && task?.length === 0) {
    return (
      <div className="col-start-4 col-end-13">
        <NoDataCard heading="No Data to Display" />
      </div>
    );
  }


  return (
    <>
    <InfiniteScroll
      dataLength={task?.length || 0}
      next={handleLoadMore}
      hasMore={hasMore()}
      loader={
        <div className="space-y-4">
          {[...Array(2)].map((_, index) => (
            <Skeleton key={`loading-${index}`} height={"150px"} />
          ))}
        </div>
      }
        endMessage={
          !hideActions && !hasMore() && task.length > 0 ? (
            <div className="text-center py-4 text-gray-500">
              <p>No more tasks to load</p>
            </div>
          ) : null
        }
      // Add these props to improve performance
      style={{ overflow: "visible" }}
      scrollThreshold={0.8}
    >
      {task.map((op, index) => {
        const { taskColor, dateText } = getTaskColorAndDate(
          op?.created_at,
          isClosed
        );

        return (
          <div
            key={`${op.id}-${index}`}
            className="bg-white flex flex-col md:flex-row justify-between rounded-md p-2 pt-2 border-l-4 mb-2 p-3"
            style={{
              borderLeftWidth: "2px",
              borderLeftColor: isClosed ? "#00B278" : taskColor,
              boxShadow: showBoxShadow ? "0px 2px 8px rgba(0, 0, 0, 0.1)" : "none"
            }}
          >
            <div className="task-start w-full md:w-[50%] pr-0 md:pr-4">
              <div>
                <span className="font-bold text-sm md:text-base block mb-1 capitalize">
                  {op?.title || "--"}
                </span>
                <div className="text-sm text-gray-400 pb-1">
                  {op?.description || "--"}
                </div>
                <div className="text-sm text-gray-500 pb-1">
                  Requested by: {op?.creator?.name || "--"}
                </div>
                <div>
                  {op.created_at ? (
                    <>
                      {dateFormater(op.created_at)}{" "}
                      <span
                        style={{
                          color: isClosed ? "#00B278" : taskColor,
                        }}
                      >
                        ({dateText})
                      </span>
                    </>
                  ) : (
                    "--"
                  )}
                </div>
              </div>
            </div>

            <div
              className={
                !isClosed
                  ? "mr-5 justify-end w-full md:w-[50%] flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-5 mt-3 sm:mt-0"
                  : "w-full md:w-[50%] flex flex-col sm:flex-row justify-around items-start sm:items-center gap-3 sm:gap-5 mt-3 sm:mt-0"
              }
            >
              {isClosed && (
                <div>
                  <p className="text-gray-500">Status</p>
                  <p className="font-bold text-sm text-gray-900 truncate">
                    {op?.status === 0 ? "Pending" : "Completed"}
                  </p>
                </div>
              )}
              
              <Button
                size="medium"
                variant="contained"
                onClick={() => handleTaskView(op)}
                className="pl-2 pr-2 sm:pl-5 sm:pr-5 w-35"
              >
                {findSlugString(op?.slug) == "assign-infusion" && op?.status === 0 ? 'Assign Infusion Date' : findSlugString(op?.slug) == "payment-status" && op?.status === 0 ? 'Update Payment Status' : findSlugString(op?.slug) == "lsm-rejection" && op?.status === 0 ? "Restart Apheresis" : "View Task"}
              </Button>
            </div>
          </div>
        );
      })}
      <ResetLSMApheresis
        open={openModel}
        taskDetails={openModelTask}
        setOpen={setModel}
      />
    </InfiniteScroll>

<BsModal open={!!paymentStatusModal} onClose={() => setPaymentStatusModal(false)} title={'Update Payment Status'}>
         <AddUpdatePayment  feasiblityId={getLastIdFromUrl(openModelTask?.redirect_uri)}  handleCloseModal={handleCloseModal}/>
     </BsModal>
</>
  );
};

export default TaskNotificationTile;
